import { render } from "./QHLSFacultyMeetDetail.vue?vue&type=template&id=35ea1ab8&scoped=true"
import script from "./QHLSFacultyMeetDetail.vue?vue&type=script&lang=js"
export * from "./QHLSFacultyMeetDetail.vue?vue&type=script&lang=js"

import "./QHLSFacultyMeetDetail.vue?vue&type=style&index=0&id=35ea1ab8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ea1ab8"]])

export default __exports__